const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2.5,
};

const icons = {
  // What We Build
  erp: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <rect x="6" y="8" width="36" height="8" rx="2" {...stroke} />
        <rect x="6" y="20" width="36" height="8" rx="2" {...stroke} opacity="0.85" />
        <rect x="6" y="32" width="36" height="8" rx="2" {...stroke} opacity="0.7" />
      </>
    ),
  },
  crm: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path
          d="M10 26l6 6 8-8"
          {...stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28 24l4 4 6-6"
          {...stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity="0.9"
        />
        <circle cx="14" cy="14" r="4" {...stroke} />
        <circle cx="34" cy="14" r="4" {...stroke} opacity="0.85" />
      </>
    ),
  },
  inventory: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <rect x="6" y="18" width="14" height="14" rx="2" {...stroke} />
        <rect x="20" y="10" width="14" height="14" rx="2" {...stroke} opacity="0.85" />
        <rect x="28" y="24" width="14" height="14" rx="2" {...stroke} opacity="0.7" />
        <path d="M8 36h10M32 12h4M30 32h8" {...stroke} strokeLinecap="round" />
      </>
    ),
  },
  project: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <rect x="6" y="10" width="10" height="28" rx="2" {...stroke} />
        <rect x="19" y="18" width="10" height="20" rx="2" {...stroke} opacity="0.85" />
        <rect x="32" y="14" width="10" height="24" rx="2" {...stroke} opacity="0.7" />
        <path d="M8 40h32" {...stroke} strokeLinecap="round" />
      </>
    ),
  },
  system: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <circle cx="12" cy="24" r="5" {...stroke} />
        <circle cx="36" cy="14" r="5" {...stroke} opacity="0.85" />
        <circle cx="36" cy="34" r="5" {...stroke} opacity="0.85" />
        <path d="M16 22l16-6M16 26l16 6" {...stroke} strokeLinecap="round" />
      </>
    ),
  },

  // Industries
  manufacturing: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <rect x="6" y="22" width="36" height="16" rx="2" {...stroke} />
        <path
          d="M12 22V14l8 4v-4l8 4"
          {...stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    ),
  },
  retail: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path d="M8 16h32l-3 18H11L8 16z" {...stroke} strokeLinejoin="round" />
        <circle cx="18" cy="38" r="2.5" fill="currentColor" />
        <circle cx="30" cy="38" r="2.5" fill="currentColor" />
      </>
    ),
  },
  healthcare: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path d="M24 8v10M19 13h10" {...stroke} strokeLinecap="round" />
        <rect x="8" y="12" width="32" height="24" rx="6" {...stroke} />
      </>
    ),
  },
  education: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path d="M6 18l18-8 18 8-18 8-18-8z" {...stroke} />
        <path d="M12 22v8c4 3 8 4 12 4s8-1 12-4v-8" {...stroke} strokeLinecap="round" />
      </>
    ),
  },
  finance: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <rect x="8" y="8" width="32" height="32" rx="4" {...stroke} />
        <path d="M14 30l6-8 4 5 6-9 4 12" {...stroke} strokeLinecap="round" />
      </>
    ),
  },
  logistics: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <rect x="6" y="18" width="24" height="14" rx="2" {...stroke} />
        <rect x="30" y="22" width="12" height="10" rx="2" {...stroke} />
        <circle cx="16" cy="36" r="2.5" fill="currentColor" />
        <circle cx="34" cy="36" r="2.5" fill="currentColor" />
      </>
    ),
  },
  realestate: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path d="M8 24l16-12 16 12v12H8V24z" {...stroke} strokeLinejoin="round" />
        <rect x="20" y="26" width="8" height="10" {...stroke} />
      </>
    ),
  },
  pharma: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <rect x="10" y="10" width="12" height="28" rx="6" {...stroke} />
        <rect x="26" y="10" width="12" height="28" rx="6" {...stroke} opacity="0.85" />
        <path d="M10 24h12" {...stroke} />
      </>
    ),
  },
  telecom: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path d="M24 8v20" {...stroke} strokeLinecap="round" />
        <circle cx="24" cy="34" r="6" {...stroke} />
        <path
          d="M10 16c4-4 10-6 14-6s10 2 14 6M6 20c5-5 11-7 18-7s13 2 18 7"
          {...stroke}
          strokeLinecap="round"
          opacity="0.8"
        />
      </>
    ),
  },

  // Projects
  fetchpad: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path d="M12 12h24v24H12z" {...stroke} strokeLinejoin="round" />
        <path d="M16 20h16M16 28h10" {...stroke} strokeLinecap="round" />
      </>
    ),
  },
  cvmaker: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path d="M14 10h20v28H14z" {...stroke} strokeLinejoin="round" />
        <path d="M18 16h12M18 22h8M18 28h10" {...stroke} strokeLinecap="round" />
      </>
    ),
  },

  // Mission & Vision
  mission: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <circle cx="24" cy="24" r="18" {...stroke} />
        <circle cx="24" cy="24" r="12" {...stroke} opacity="0.85" />
        <circle cx="24" cy="24" r="6" {...stroke} opacity="0.7" />
        <path
          d="M30 18l7-7m-4 0h4v4"
          {...stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M30 18L22 26" {...stroke} strokeLinecap="round" />
      </>
    ),
  },
  vision: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path
          d="M4 24s7-12 20-12 20 12 20 12-7 12-20 12S4 24 4 24z"
          {...stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="24" cy="24" r="6" {...stroke} />
        <circle cx="24" cy="24" r="2.5" fill="currentColor" />
        <path
          d="M34 10l1.5 3.5L39 15l-3.5 1.5L34 20l-1.5-3.5L29 15l3.5-1.5L34 10z"
          fill="currentColor"
          opacity="0.9"
        />
      </>
    ),
  },

  // Meta flagship services
  whatsapp: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path
          d="M24 4C12.97 4 4 12.87 4 23.75c0 3.5 1.02 6.76 2.79 9.51L4 44l11.18-2.64A20.1 20.1 0 0 0 24 43.5c11.03 0 20-8.87 20-19.75S35.03 4 24 4z"
          {...stroke}
          strokeLinejoin="round"
        />
        <path
          d="M17.5 14.5c-.55 0-1.45.21-1.98.98-.53.77-2.02 1.97-2.02 4.8 0 2.83 2.07 5.57 2.36 5.95.29.39 4.01 6.45 9.92 8.65 4.95 1.84 5.96 1.48 7.04 1.38 1.07-.09 3.47-1.42 3.96-2.79.49-1.37.49-2.54.34-2.79-.14-.25-.53-.4-1.11-.7-.58-.3-3.47-1.71-4-1.9-.54-.2-.93-.3-1.32.3-.39.59-1.52 1.91-1.87 2.3-.34.39-.69.44-1.27.15-.58-.3-2.46-.9-4.69-2.89-1.73-1.55-2.9-3.46-3.24-4.04-.34-.59-.04-.91.26-1.2.26-.26.58-.68.87-1.02.29-.34.39-.59.58-.98.2-.39.1-.73-.05-1.02-.14-.3-1.29-3.15-1.79-4.3-.46-1.09-.95-.9-1.31-.91-.34-.02-.73-.02-1.12-.02z"
          fill="currentColor"
        />
      </>
    ),
  },
  ads: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <path
          d="M8 22v8a4 4 0 0 0 8 0v-8M12 26H8a4 4 0 0 0 4 4M24 14l14-4v28l-14-4V14z"
          {...stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26 18l9-2.5v17l-9-2.5M34 28.5c2.5 1 6 1.5 8 2.5M34 19.5c2.5-1 6-1.5 8-2.5"
          {...stroke}
          strokeLinecap="round"
        />
      </>
    ),
  },
  webhooks: {
    viewBox: "0 0 48 48",
    nodes: (
      <>
        <circle cx="12" cy="14" r="4" {...stroke} />
        <circle cx="12" cy="34" r="4" {...stroke} />
        <circle cx="36" cy="24" r="4" {...stroke} />
        <path d="M12 18v12M15 18l14-6M15 30l14 6M24 24h8" {...stroke} strokeLinecap="round" />
      </>
    ),
  },

  // Hero perks (bootstrap style, 16x16)
  clock: {
    viewBox: "0 0 16 16",
    nodes: (
      <>
        <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm7.646-8.354-3.5-3.5a.5.5 0 0 0-.708.708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708z" />
        <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
      </>
    ),
  },
  refresh: {
    viewBox: "0 0 16 16",
    nodes: (
      <>
        <path d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
      </>
    ),
  },
  doc: {
    viewBox: "0 0 16 16",
    nodes: (
      <>
        <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
        <path d="M10.854 5.854a.5.5 0 0 0-.708-.708L7.5 7.793 6.354 6.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
      </>
    ),
  },

  // Social
  github: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27s1.36.09 2 .27c1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
    ),
  },
  linkedin: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
    ),
  },
  facebook: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
    ),
  },
  instagram: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8s.01 2.445.048 3.298c.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.417.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.445-.01 3.298-.048c.852-.04 1.434-.174 1.942-.372a3.9 3.9 0 0 0 1.417-.923c.445-.445.718-.891.923-1.417.198-.51.333-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.298c-.04-.852-.174-1.433-.372-1.942a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.942-.372C10.445.01 10.172 0 8 0zm0 1.442c2.136 0 2.39.008 3.233.047.78.036 1.203.166 1.485.276.374.145.64.319.92.599.28.28.454.546.6.92.11.282.24.705.275 1.485.039.844.047 1.097.047 3.233s-.008 2.39-.047 3.233c-.036.78-.166 1.203-.276 1.485a2.5 2.5 0 0 1-.599.92c-.28.28-.546.454-.92.6-.282.11-.705.24-1.485.276-.843.039-1.097.047-3.233.047s-2.39-.008-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.599 2.5 2.5 0 0 1-.6-.92c-.11-.282-.24-.705-.275-1.485C1.45 10.39 1.442 10.136 1.442 8s.008-2.39.047-3.233c.036-.78.166-1.203.276-1.485.145-.374.319-.64.599-.92s.546-.454.92-.6c.282-.11.705-.24 1.485-.275.843-.04 1.097-.047 3.233-.047zm0 2.452a4.106 4.106 0 1 0 0 8.212 4.106 4.106 0 0 0 0-8.212zm0 6.77a2.664 2.664 0 1 1 0-5.328 2.664 2.664 0 0 1 0 5.328zm5.21-6.936a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0z" />
    ),
  },

  // Utility
  check: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
    ),
  },
  meta: {
    viewBox: "0 0 24 24",
    nodes: (
      <>
        <circle cx="18" cy="12" r="6" fill="none" stroke="currentColor" strokeWidth="2.5" />
        <circle cx="6" cy="12" r="6" fill="none" stroke="currentColor" strokeWidth="2.5" />
      </>
    ),
  },
  mail: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.143l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z" />
    ),
  },
  pin: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
    ),
  },
  menu: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
    ),
  },
  close: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
    ),
  },
  arrow: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
    ),
  },
  external: {
    viewBox: "0 0 16 16",
    nodes: (
      <path d="M3.5 2a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 1 0v3a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5v-11A1.5 1.5 0 0 1 3.5 1h3a.5.5 0 0 1 0 1zM10 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V2.7l-6.146 6.147a.5.5 0 0 1-.708-.708L12.293 2H10.5a.5.5 0 0 1-.5-.5" />
    ),
  },
};

function Icon({ name, size = 24, className = "", ...rest }) {
  const icon = icons[name];
  if (!icon) return null;
  return (
    <svg
      viewBox={icon.viewBox}
      width={size}
      height={size}
      className={className}
      role="img"
      fill="currentColor"
      aria-hidden="true"
      {...rest}
    >
      {icon.nodes}
    </svg>
  );
}

export default Icon;
